<template>
  <div class="contact">
    <h1 class="contactTitle">{{ $t("app.contact.title") }}</h1>
    <h2 class="contactSubtitle">{{ $t("app.contact.subtitle") }}</h2>
    <div class="contactCard">
      <vs-row>
        <vs-col lg="5" sm="12" class="contactCardInformationCol">
          <div class="contactCardInformation">
            <div class="contactCardInfoData">
              <h3>{{ $t("app.contact.information.title") }}</h3>
              <p>{{ $t("app.contact.information.description") }}</p>
              <div class="contactCardInfoDataContent">
                <p><i class='bx bxs-phone' />{{ $t("app.contact.information.number") }}</p>
                <p><i class='bx bx-mail-send' />{{ $t("app.contact.information.mail") }}</p>
                <p><i class='bx bx-map-pin' />{{ $t("app.contact.information.address") }}</p>
              </div>
              <div class="contactCardInfoSocial">
                <vs-button
                  icon
                  color="#000000"
                  relief
                  @click="() => openSocial('fb')"
                  animation-type="rotate"
                >
                  <i class='bx bxl-facebook-circle' />
                  <template #animate >
                    <i class='bx bxl-facebook' />
                  </template>
                </vs-button>
                <vs-button
                  icon
                  color="#000000"
                  relief
                  @click="() => openSocial('insta')"
                  animation-type="rotate"
                >
                  <i class='bx bxl-instagram-alt' />
                  <template #animate >
                    <i class='bx bxl-instagram' />
                  </template>
                </vs-button>
              </div>
            </div>
            <img
              class="contactCardInformationVectors"
              src="../assets/ContactCardVectors.svg"
              alt="ContactCardVector"
              width="40%"
            >
          </div>
        </vs-col>
        <vs-col lg="7" sm="12">
          <div class="contactCardForm">
            <vs-row>
              <vs-col lg="6" sm="12" class="contactCardFormCol">
                <vs-input
                  :label-placeholder="i18('app.contact.form.firstName')"
                  v-model="firstName"
                  dark
                  required
                />
              </vs-col>
              <vs-col lg="6" sm="12" class="contactCardFormCol">
                <vs-input
                  :label-placeholder="i18('app.contact.form.lastName')"
                  v-model="lastName"
                  dark
                />
              </vs-col>

              <vs-col lg="6" sm="12" class="contactCardFormCol">
                <vs-input
                  :label-placeholder="i18('app.contact.form.mail')"
                  v-model="mail"
                  dark
                  @blur="validateMail"
                >
                  <template v-if="!validMail && mail !== ''" #message-danger>
                    {{ i18('app.contact.form.mail.error') }}
                  </template>
                </vs-input>
              </vs-col>
              <vs-col lg="6" sm="12" class="contactCardFormCol">
                <vs-input
                  :label-placeholder="i18('app.contact.form.phoneNumber')"
                  v-model="phoneNumber"
                  dark
                />
              </vs-col>
              <vs-col w="12" class="contactCardFormCol">
                <h4 tabindex="0">{{i18('app.contact.form.serviceRequest')}}</h4>
              </vs-col>
              <vs-col w="12" class="contactCardFormColServices">
                <vs-checkbox v-for="(option, index) in options" :key="index" :val="option" v-model="services">
                  {{ option }}
                </vs-checkbox>
              </vs-col>
              <vs-col w="12" class="contactCardFormCol">
                <label
                  for="vs-input--message"
                  class="contactCardFormMessageLabel"
                >
                  {{ i18('app.contact.form.message') }}
                </label>
                <vs-input
                  id='message'
                  v-model="message"
                  dark
                />
              </vs-col>
              <vs-col w="12">
                <div class="contactButtonWrapper">
                  <vs-button :disabled="!validForm()" size="large" @click="sendForm" class="contactButton">
                    {{ $t("app.contact.form.button.writeMessage") }}
                    <template #animate >
                      <i class='bx bx-mail-send' /> {{ $t("app.contact.form.button.send") }}
                    </template>
                  </vs-button>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { sendMessage } from '../server/serverHelper';

const cloneAttributes = (target, source) => {
  [...source.attributes]
    .forEach((attr) => {
      target.setAttribute(attr.nodeName, attr.nodeValue);
    });
};

export default {
  name: 'Contact',
  props: {
    contactForm: Object,
    setContactForm: Function,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      mail: '',
      validMail: true,
      phoneNumber: '',
      services: [],
      message: '',
      sending: false,
      options: [
        this.$t('app.contact.form.services.design'),
        this.$t('app.contact.form.services.printing'),
        this.$t('app.contact.form.services.webDesign'),
        this.$t('app.contact.form.services.other'),
      ],
    };
  },
  methods: {
    openSocial(type) {
      let url;
      switch (type) {
        case 'fb':
          url = 'https://www.facebook.com/';
          break;
        case 'insta':
          url = 'https://www.instagram.com/';
          break;
        default:
          break;
      }
      setTimeout(() => {
        window.open(url);
      }, 500);
    },
    validateMail() {
      if (this.mail !== '') {
        this.validMail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.mail);
      }
    },
    validForm() {
      let valid = false;
      if (this.firstName && this.mail && this.validMail && this.message && this.services.length > 0) {
        valid = true;
      }
      return valid;
    },
    sendForm() {
      const form = {
        firstName: this.firstName,
        lastName: this.lastName,
        mail: this.mail,
        phoneNumber: this.phoneNumber,
        services: this.services,
        message: this.message,
      };
      const response = sendMessage(form);
      console.log(response);
      this.setContactForm({});
    },
    i18(id) {
      return this.$t(id);
    },
  },
  mounted() {
    // setting form
    const { service, packageName } = this.contactForm;
    this.services = service ? [service] : [];
    this.message = packageName ? `${packageName}\n` : '';

    // Replacing vs-input for a textarea in a hacky way since there's no support for a textarea yet
    const messageInput = document.getElementById('vs-input--message');
    const messageTextArea = document.createElement('textarea');
    cloneAttributes(messageTextArea, messageInput);
    messageTextArea.setAttribute('rows', 6);
    messageTextArea.value = packageName ? `${packageName}\n` : '';
    messageTextArea.setAttribute('placeholder', this.i18('app.contact.form.message.placeholder'));
    messageTextArea.style.width = '95%';
    messageTextArea.style.color = 'rgb(44, 62, 80)';
    messageTextArea.style.fontFamily = 'Poppins';
    const vm = this;
    function customBinding(event) {
      vm.message = event.target.value;
    }
    messageTextArea.addEventListener('change', customBinding);
    messageInput.replaceWith(messageTextArea);
  },
};
</script>

<style scoped>
.contactTitle {
  font-size: 2.4rem;
  margin: 0 0;
}

.contactSubtitle {
  font-size: 2rem;
  font-weight: 400;
  margin: 0 0;
}

.contactCard {
  margin-top: 1rem;
  background: #ffffff;
  width: 100%;
  -webkit-box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, var(--vs-shadow-opacity));
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, var(--vs-shadow-opacity));
  border-radius: 20px;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  position: relative;
  display: flex;
}

.contactCardInformation {
  background-color: #000000;
  color: #ffffff;
  width: 100%;
  height: 100%;
  border-radius: 20px 0 0 20px;
  position: relative;
}

.contactCardInformationCol {
  height: 100%;
}

@media screen and (max-width: 900px) {
  .contactCardInformationCol {
    height: auto;
  }

  .contactCardInformation {
    background-color: #000000;
    color: #ffffff;
    width: 100%;
    height: 100%;
    border-radius: 20px 20px 0 0;
    position: relative;
  }
}

.contactCardInformationVectors {
  position: absolute;
  bottom: 0;
  right: 0;
}

.contactCardInfoData {
  padding: 2rem;
  color:#ffffff;
}

.contactCardInfoData h3{
  font-size: 1.6rem;
  font-weight: 400;
  margin: 0;
}

.contactCardInfoDataContent {
  padding: 1rem;
}

.contactCardInfoDataContent p {
  display: flex;
  align-items: center;
}

.contactCardInfoDataContent i {
  margin-right: 2rem;
  font-size: 1.3rem;
}

.contactCardInfoSocial {
  display: flex;
  margin-top: 3rem;
}

.contactCardForm {
  width: 100%;
  padding: 1rem;
}

.contactCardFormCol {
  padding: 1rem;
}

.contactCardFormColServices {
  padding: 0 3rem 0 1rem !important;
  display: flex !important;
  justify-content: space-between !important;
  flex-wrap: wrap;
}

.contactCardFormColMesage {
  padding: 0 1rem !important;
}

.contactCardForm h4{
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0;
}

.contactCardFormMessageLabel {
  padding-left: 0.7rem;
  font-size: 0.75rem;
}

.contactButtonWrapper {
  display: flex;
  justify-content: flex-end;
  padding: 0 2rem;
}

.contactButton {
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
